import React from 'react';
import './MemberFooter.css';

const MemberFooter = () => {
  return (
    <footer className="member-footer">
      <div className="member-footer-container">
        <p>© 2025 Himlayang Pilipino Memorial Park. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default MemberFooter;
